module.exports = __webpack_public_path__ + "media/images/features/modification/eyecatch-question-c1cb2feeacb9ac5390d85925aa8b3447.png";